import { clerkEnabled } from "@/services/clerk";
import { useMe } from "./useMe";

/**
 * What the button that leads to `/apply` should say.
 *
 * "Apply for membership" is right until somebody has applied. After that the
 * same words ask them to do a thing they have done, and the page they land on
 * is one they are editing rather than filling in. There is only one action
 * left there, so the button names it.
 *
 * Signed out we cannot know, and the answer is the same either way: apply.
 */
export function useApplyCta(): string {
  const { data: me } = useMe(clerkEnabled);
  return me?.application?.status === "pending"
    ? "Update application"
    : "Apply for membership";
}

/**
 * Whether a signed-in member should be offered the application at all.
 *
 * Not being a member is the usual reason. The other is a membership that
 * arrived before a listing did: somebody sponsored signs up to full access,
 * and is listed only once an application is approved. Keyed on `isMember`
 * alone, the offer vanished the moment the sponsorship landed, and the one
 * thing left for them to do had no way in.
 */
export function useOffersApplication(
  isMember: boolean,
  listed: boolean | undefined
): boolean {
  const { data: me } = useMe(clerkEnabled);
  if (!isMember) return true;
  return listed === false && me?.application?.status !== "approved";
}

export default useApplyCta;
